import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import * as api from '../lib/api';

/**
 * useShiftStore — which facility the attendant is currently working.
 *
 * Most staff cover one yard, but some cover several, and every attendant
 * endpoint is facility-scoped. Holding the selection here means no screen has
 * to thread a facility id through props, and the choice survives a reload so
 * a tablet that goes to sleep mid-shift comes back where it was.
 */
export const useShiftStore = create()(
  persist(
    (set, get) => ({
      facilities: [],
      facilityId: null, // public_id
      status: 'idle',
      error: null,

      load: async () => {
        set({ status: 'loading', error: null });
        try {
          const { facilities } = await api.myFacilities();
          const current = get().facilityId;
          // Keep the remembered facility only if it is still assigned to them.
          const stillAssigned = facilities.some((f) => f.public_id === current);
          set({
            facilities,
            facilityId: stillAssigned ? current : facilities[0]?.public_id ?? null,
            status: 'ready',
          });
        } catch (err) {
          set({ status: 'error', error: err.message });
        }
      },

      setFacility: (facilityId) => set({ facilityId }),

      current: () => get().facilities.find((f) => f.public_id === get().facilityId) ?? null,
    }),
    {
      name: 'parktle:shift',
      version: 1,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ facilityId: state.facilityId }),
    },
  ),
);
